import React from 'react'

export default function Conclusiones() {
  return (
    <div>
      Conclusiones
    </div>
  )
}
